import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';

import CustomTable from '../../../components/CustomTable';
// import { REGISTRADO, EMITIDO, RECHAZADO, ANULADO } from '../../../common/types/comprobanteEstadoType';
import { CLAIM } from '../../../common/types/parametroType';
import auth from '../../../common/utility/auth';

const REGISTRADO = 1;
const IMPORTADO = 2;
// const RECHAZADO = 3;
const ANULADO = 3;
const APROBADO = 4;

export default function ResultList(props) {

    const flagClaim = props.claim ?? false;

    const renderColor = (row) => {
        if (row.idCotizacionEstado === REGISTRADO)
            return 'blue';
        if (row.idCotizacionEstado === IMPORTADO)
            return 'green';
        if (row.idCotizacionEstado === ANULADO)
            return 'red';
        if (row.idCotizacionEstado === APROBADO)
            return 'orange';
    };

    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title="Ver">
                                <Button
                                    type="primary"
                                    icon="eye"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onView(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title="Copiar">
                                <Button
                                    type="primary"
                                    icon="copy"
                                    size={"small"}
                                    loading={props.loadingCopy}
                                    //disabled={ auth.user().idProducto==5?false:true}
                                    onClick={() => props.onCopy(row)}
                                />
                            </Tooltip>

                            {/*                <Tooltip placement="top" title="Enviar correo">
                                <Button
                                    type="primary"
                                    icon="mail"
                                    size={"small"}
                                    disabled={row.idCotizacionEstado !== ANULADO ? false : true}
                                    onClick={() => props.onCorreo(row)}
                                />
                            </Tooltip> */}
                            <Tooltip placement="top" title="Anular">
                                <Button
                                    type="danger"
                                    icon="close"
                                    size={"small"}
                                    disabled={row.idCotizacionEstado === REGISTRADO ? row.flagAprobado : true}
                                    onClick={() => props.onAnular(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title="Aprobar">
                                <Button
                                    type="success"
                                    icon="check"
                                    size={"small"}
                                    disabled={row.idCotizacionEstado === REGISTRADO ? row.flagAprobado : true}
                                    onClick={() => props.onAprobar(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Editar">
                                <Button
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    disabled={row.idCotizacionEstado === REGISTRADO ? row.flagAprobado : true}
                                    onClick={() => props.onEdit(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Imprimir">
                                <Button
                                    type="primary"
                                    icon="printer"
                                    size={"small"}
                                    loading={props.loadingImprimir}
                                    onClick={() => props.onImprimir(row)}
                                />
                            </Tooltip>

                        </div>
                    )
                },
                {
                    title: 'Serie',
                    dataIndex: 'serie',
                    key: 'serie',
                    sorter: true
                },
                {
                    title: 'Documento',
                    dataIndex: 'documento',
                    key: 'documento',
                    sorter: true
                },
                {
                    title: 'Fecha',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    sorter: true
                },
                {
                    title: 'Tipo Documento',
                    dataIndex: 'tipoDocumentoCliente',
                    key: 'tipoDocumentoCliente',
                    sorter: true
                },
                {
                    title: 'Número Documento',
                    dataIndex: 'numeroDocumentoCliente',
                    key: 'numeroDocumentoCliente',
                    sorter: true
                },
                {
                    title: 'Cliente',
                    dataIndex: 'razonSocialCliente',
                    key: 'razonSocialCliente',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "150px" }}>{value}</div>
                    )
                },
                {
                    title: 'Proyecto',
                    dataIndex: 'proyecto',
                    key: 'proyecto',
                    sorter: true
                },
                {
                    title: 'Modelo',
                    dataIndex: 'modelo',
                    key: 'modelo',
                    sorter: true,
                    className: flagClaim ? 'show' : 'hide'
                },
                {
                    title: 'Vendedor',
                    dataIndex: 'vendedor',
                    key: 'vendedor',
                    sorter: true
                },
                {
                    title: 'Moneda',
                    dataIndex: 'moneda',
                    key: 'moneda',
                    sorter: true
                },
                {
                    title: 'Sub Total',
                    dataIndex: 'subTotal',
                    key: 'subTotal',
                    align: 'right',
                    sorter: true,
                    render: (value) => (
                        <span>{value.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Igv',
                    dataIndex: 'igv',
                    key: 'igv',
                    align: 'right',
                    sorter: true,
                    render: (value) => (
                        <span>{value.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Total',
                    dataIndex: 'total',
                    key: 'total',
                    align: 'right',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Estado',
                    dataIndex: 'nombreCotizacionEstado',
                    key: 'nombreCotizacionEstado',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={renderColor(row)}>{value}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );
}